export const MAX_PERCENTAGE_LICITACAO = '5';
export const MAX_PERCENTAGE_PERFORMANCE = '30';
export const MAX_TOOLTIP_LICITACAO = 1.99;
export const MAX_TOOLTIP_PERFORMANCE = 5.99;

export const DEFAULT_PERCENTAGE_LICITACAO = 1.0;
export const DEFAULT_PERCENTAGE_PERFORMANCE = 5.0;

export const COOKIE_NAME = 'juntoCampaignInfo';
export const USER_ACCESS_TOKEN = 'ncl_uac';
export const USER_REFRESH_TOKEN = 'ncl_urt';

export const MESSAGE_BOX_INFO = 1;
export const MESSAGE_BOX_SUCCESS = 5;
export const MESSAGE_BOX_WARNING = 3;

export const DOCUMENT_STATUS_ANALISE = 1;
export const DOCUMENT_STATUS_VIGENTE = 2;
export const DOCUMENT_STATUS_A_VENCER = 3;
export const DOCUMENT_STATUS_VENCIDA = 4;
export const DOCUMENT_STATUS_PREPARANDO = 5;

export const PRIVACY_POLICY_TERMS_URL = `${process.env.REACT_APP_SITE_URL}/politica-privacidade`;
export const TERMS_OF_USE_URL = `${process.env.REACT_APP_SITE_URL}/termos-de-uso`;

export const DISCOUNT_TYPE = {
  CREDITS: 1,
  COUPON: 2,
};

export const COUPON_DISCOUNT_TYPE = {
  VALUE: 1,
  PERCENTAGE: 2,
};
